import axios from "@/lib/axios";

const getTerminate = (custCode: string | undefined) => {
  return axios.get(`/facility/facility_agreements/terminate_cancels/${custCode}/terminate`);
}

export default getTerminate;